import { FC } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faSpinner,
  faTriangleExclamation,
} from '@fortawesome/pro-solid-svg-icons';
import type { MediaId } from 'models/Media';
import { useMediaUrl } from 'hooks/useMediaUrl';
import { useTranslations } from 'next-intl';

interface Props {
  mediaId: MediaId;
  className?: string;
}

// An <audio controls> for a stored media file.
export const MediaAudio: FC<Props> = ({ mediaId, className }) => {
  const t = useTranslations();
  const { url, status, onError } = useMediaUrl(mediaId);

  if (status === 'ready' && url) {
    return (
      <audio
        controls
        preload="metadata"
        src={url}
        className={className}
        onError={onError}
      />
    );
  }

  return (
    <div className={styles.placeholder}>
      <FontAwesomeIcon
        icon={status === 'error' ? faTriangleExclamation : faSpinner}
        className={status === 'error' ? undefined : 'animate-spin'}
        aria-hidden="true"
      />
      <span>
        {status === 'error' ? t('media.unavailable') : t('common.loading')}
      </span>
    </div>
  );
};

const styles = {
  placeholder:
    'flex h-9 items-center gap-2 rounded-md bg-gray-100 px-3 text-sm text-gray-400',
};
